const path = '/login/start';
const name = 'sign-in';

const config = {
  height: 600,
  location: 'no',
  personalbar: 'no',
  status: 'no',
  toolbar: 'no',
  width: 450,
};

export default function openSignInDialog() {
  // Determine screen offset for multi-screen setups
  const screenLeft = window.screenLeft || window.screenX || 0;
  const screenTop = window.screenTop || window.screenY || 0;

  // Get the current window width & height
  const doc = document.documentElement;
  const width = window.innerWidth || doc.clientWidth || window.screen.width;
  const height = window.innerHeight || doc.clientHeight || window.screen.height;

  // Calculate the offset for the dialog
  const left = screenLeft + (width - config.width) / 2;
  const top = screenTop + (height - config.height) / 2;

  const feats = Object.entries({ ...config, top, left })
    .map(pair => pair.join('='))
    .join(', ');

  return window.open(path, name, feats);
}
